import React, { useRef, useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { TextField } from "../../index";
import './password.scss';

export const Password = ({
    label = "Password",
    onChange = () => { },
    onKeyUp = () => { },
    onKeyDown = () => { },
    ...props
}) => {

    const textFieldRef = useRef(null);
    const [pwInputType, setPwInputType] = React.useState('password');

    const handleOnChange = (event) => {
        onChange(event);
    }

    const handleOnKeyUp = (e) => {
        handleOnChange(e);
        onKeyUp(e);
    }

    const handleOnKeyDown = (event) => {
        onKeyDown(event);
    };

    const handlePostIconOnClick = (event) => {
        event.preventDefault();
        if (textFieldRef.current) {
            const tfRef = textFieldRef.current;

            if (pwInputType === 'password') {
                setPwInputType('text');
            } else {
                setPwInputType('password');
            }
            tfRef.focus();
        }
    }

    useEffect(() => {
        // Moving cursor to the end
        if (textFieldRef?.current && textFieldRef?.current?.value.length > 0) {
            textFieldRef.current.selectionStart = textFieldRef.current.value.length;
            textFieldRef.current.selectionEnd = textFieldRef.current.value.length;
        }
    }, [pwInputType]);

    return (
        <TextField
            {...props}
            ref={textFieldRef}
            className="bsw-password"
            label={label}
            onChange={handleOnChange}
            onKeyUp={handleOnKeyUp}
            onKeyDown={handleOnKeyDown}
            postIcon={{
                icon: pwInputType === 'password' ? 'visibility-off' : 'visibility-on',
                show: true,
                btnProps: {
                    onClick: handlePostIconOnClick
                }
            }}
            type={pwInputType}
        />
    )
}

Password.propTypes = {
    label: PropTypes.string,
    onChange: PropTypes.func,
    onKeyUp: PropTypes.func,
    onKeyDown: PropTypes.func,
}